import { BigNumber } from 'bignumber.js';

// Types & interfaces for the LeaseSyncService
export enum ObjectType {
	FILE = 0,
	FOLDER = 1
}
export interface SingleMetadataV1 {
	name: string;
	created: BigNumber| number;
	lastModified: BigNumber| number;
	eTag: string;
	type: ObjectType;
}
